<template>
  <div class="node-message">
    <div class="node-message__avatar_container">
      <img class="node-message__avatar" :src="avatar" alt="avatar" />
    </div>

    <div v-if="$slots.default" class="node-message__content">
      <slot />
    </div>
    <div v-else class="node-message__content">
      <TextMessage :message-text="somethingWentWrongText" />
      <TextMessage :message-text="message" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n/dist/vue-i18n';
import chatbotLogo from '~/assets/svg/new-chatbot-logo.svg';
import TextMessage from '~/components/conversation/chatMessage/TextMessage.vue';

export default {
  name: 'ErrorMessage',
  components: { TextMessage },
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    const avatar = computed(() => chatbotLogo);

    return {
      avatar,
      somethingWentWrongText: `❌ ${t('conversation.errorMessage.somethingWentWrongText')}`,
    };
  },
};
</script>

<style scoped lang="scss">
.node-message {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-top: $bb-spacing-6;

  &__avatar_container {
    background: #fdb91a;
    border-radius: $bb-spacing-6;
    width: $bb-spacing-9;
    height: $bb-spacing-9;
    display: flex;
  }

  &__avatar {
    @include bb-medium-text-styles('xs');

    width: $bb-spacing-5;
    height: $bb-spacing-5;
    margin: auto;
    flex-shrink: 0;

    color: $bb-neutral-0;
    text-align: center;
    line-height: $bb-spacing-6;
  }

  &__content {
    padding: $bb-spacing-3 $bb-spacing-4;
    line-height: normal;

    background: $bb-interface-10;
    border-radius: $bb-spacing-6 $bb-spacing-6 $bb-spacing-6 1px;
    max-width: 80%;
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-2;

    .slow-fade-enter-active,
    .slow-fade-leave-active {
      transition: opacity 3s; /* Adjust duration for slower/faster effect */
    }

    .slow-fade-enter-from,
    .slow-fade-leave-to {
      opacity: 2;
    }

    .divider {
      border: 0;
      height: 1px;
      background-color: #ccc;
      margin-top: $bb-spacing-1;
      margin-bottom: $bb-spacing-1;
    }
  }
}
</style>
